<template>
  <v-container fluid grid-list-md id="page-body" :class="{'px-0': $vuetify.breakpoint.smAndDown}">

    <v-layout row>
      <v-flex xs12>
        <bookmarkcards :bookmarks="designInspirationBookmarks" v-if="is_data_fetched"></bookmarkcards>
      </v-flex>
      <v-flex xs12>
        <bookmarkcards :bookmarks="designPublicationBookmarks" v-if="is_data_fetched"></bookmarkcards>
      </v-flex>
      <v-flex xs12>
        <bookmarkcards :bookmarks="designUxBookmarks" v-if="is_data_fetched"></bookmarkcards>
      </v-flex>
    </v-layout>

  </v-container>
</template>

<script>
import dataApi from '../services/ApiService'

export default {
  name: 'Design',
  data: () => ({
      loading: false,
      is_data_fetched: false,
      designInspirationBookmarks: [],
      designPublicationBookmarks: [],
      designUxBookmarks: []
  }),
  methods: {
    getDataFile() {
      dataApi.fetchDataFile ('design-inspiration-bookmarks.json')
      .then(response => {
        if (Object.keys(response).length) {
          this.designInspirationBookmarks = response.bookmarkList
          this.is_data_fetched = true
        }
      })
      .catch(error => {
        // eslint-disable-next-line no-console
        console.log(error)
      })
      
      dataApi.fetchDataFile ('design-publication-bookmarks.json')
      .then(response => {
        if (Object.keys(response).length) {
          this.designPublicationBookmarks = response.bookmarkList
          this.is_data_fetched = true
        }
      })
      .catch(error => {
        // eslint-disable-next-line no-console
        console.log(error)
      })

      dataApi.fetchDataFile ('design-ux-bookmarks.json')
      .then(response => {
        if (Object.keys(response).length) {
          this.designUxBookmarks = response.bookmarkList
          this.is_data_fetched = true
        }
      })
      .catch(error => {
        // eslint-disable-next-line no-console
        console.log(error)
      })

    }
  },
  mounted () {
    this.getDataFile()
  }
}
</script>

<style lang="scss" scoped>
</style>
